import { httpClient } from "shared/services/http/httpClient";
import { PaymentMethod } from "../models/paymentMethodsModel";

const paymentMethodsService = () => {
  const getMethodPayment = async (): Promise<PaymentMethod[]> => {
    const res = await httpClient.get(`payment-methods`);
    return res;
  };
  return {
    getMethodPayment
  };
};

export default paymentMethodsService;